import React, { useState, useEffect, useRef } from 'react';
import { STitle } from '../Widget';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import './index.less';

interface IToolsBoxProps {
  title?: string;
  leftText?: string;
  rightText?: string;
  id?: string;
  arrowImg?: string;
  leftBackgroundImage?: string;
  rightBackgroundImage?: string;
  onComplete?: () => void;
}

const ToolsBox: React.FunctionComponent<IToolsBoxProps> = ({
  title,
  leftText,
  rightText,
  id,
  arrowImg = ArrowImg,
  leftBackgroundImage,
  rightBackgroundImage,
  onComplete,
}) => {
  const [deepfakeFlag, setDeepfakeFlag] = useState(false);
  const [deepfakeFlag2, setDeepfakeFlag2] = useState(false);

  // 使用 useRef 存储 onComplete，避免将其作为依赖项导致无限循环
  const onCompleteRef = useRef(onComplete);
  const hasCalledRef = useRef(false);

  // 更新 ref 的值，但不作为依赖项
  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  // 只在两个标志都为 true 时调用一次 onComplete
  useEffect(() => {
    if (deepfakeFlag && deepfakeFlag2) {
      if (onCompleteRef.current && !hasCalledRef.current) {
        hasCalledRef.current = true;
        onCompleteRef.current();
      }
    } else {
      // 当任一标志为 false 时，重置调用标志，允许再次调用
      hasCalledRef.current = false;
    }
  }, [deepfakeFlag, deepfakeFlag2]);

  const handleLeftClick = () => {
    setDeepfakeFlag(true);
  };

  const handleRightClick = () => {
    setDeepfakeFlag2(true);
  };

  return (
    <div className="tools-box-container">
      {title && <STitle title={title} />}
      <div className="tools-box" id={id}>
        <div
          className="tools-left"
          onClick={handleLeftClick}
          style={
            leftBackgroundImage
              ? { backgroundImage: `url(${leftBackgroundImage})` }
              : undefined
          }
        >
          {!deepfakeFlag && <img src={arrowImg} alt="" />}
          {deepfakeFlag && (
            <span className="focus-in-expand-fwd">{leftText}</span>
          )}
        </div>
        <div
          className="tools-right"
          onClick={handleRightClick}
          style={
            rightBackgroundImage
              ? { backgroundImage: `url(${rightBackgroundImage})` }
              : undefined
          }
        >
          {!deepfakeFlag2 && <img src={arrowImg} alt="" />}
          {deepfakeFlag2 && (
            <span className="focus-in-expand-fwd">{rightText}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ToolsBox);
